import { useState } from "react";
import { Card, Stack } from "@/components/ui";
import { useIndicadoresImpuestoAdmin } from "../hooks/use-indicadores-impuesto-admin";
import { IndicadoresHeader } from "./IndicadoresHeader";
import { IndicadorCrearForm } from "./IndicadorCrearForm";
import { IndicadoresTable } from "./IndicadoresTable";

/**
 * Página de administración del catálogo de indicadores de impuesto
 * (V0/V5/V7 · P45 · docs/specs/SPEC_Modulo_IndicadoresImpuesto.md).
 * Catálogo corto y de baja frecuencia de cambio · sin paginación, a
 * diferencia de la mayoría de los catálogos admin del portal.
 */
export function AdminIndicadoresImpuestoPage() {
  const [modoCrear, setModoCrear] = useState(false);
  const { data: indicadores } = useIndicadoresImpuestoAdmin();

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:px-6">
      <IndicadoresHeader total={indicadores.length} modoCrear={modoCrear} onIniciarCrear={() => setModoCrear(true)} />
      <Stack gap="md">
        {modoCrear ? <IndicadorCrearForm onSalir={() => setModoCrear(false)} /> : null}
        <Card padding="lg">
          <IndicadoresTable indicadores={indicadores} />
        </Card>
      </Stack>
    </div>
  );
}
